export type ServiceArea = {
  slug: string;
  city: string;
  state: string;
};

export const serviceAreas: ServiceArea[] = [
  { slug: "plano", city: "Plano", state: "TX" },
  { slug: "irving", city: "Irving", state: "TX" },
  { slug: "garland", city: "Garland", state: "TX" },
  { slug: "frisco", city: "Frisco", state: "TX" },
  { slug: "mckinney", city: "McKinney", state: "TX" },
  { slug: "grand-prairie", city: "Grand Prairie", state: "TX" },
  { slug: "mesquite", city: "Mesquite", state: "TX" },
  { slug: "carrollton", city: "Carrollton", state: "TX" },
  { slug: "richardson", city: "Richardson", state: "TX" },
  { slug: "denton", city: "Denton", state: "TX" },
  { slug: "arlington", city: "Arlington", state: "TX" },
  { slug: "lewisville", city: "Lewisville", state: "TX" },
  { slug: "coppell", city: "Coppell", state: "TX" },
  { slug: "addison", city: "Addison", state: "TX" },
  { slug: "duncanville", city: "Duncanville", state: "TX" },
  { slug: "lancaster", city: "Lancaster", state: "TX" },
];

export const getServiceArea = (slug: string) =>
  serviceAreas.find((a) => a.slug === slug);
